import { render, staticRenderFns } from "./Passthrough.vue?vue&type=template&id=ef607328&"
import script from "./Passthrough.vue?vue&type=script&lang=js&"
export * from "./Passthrough.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports